// Termos de uso PRÓPRIOS do cliente — o campo "URL dos seus termos de uso" de
// "Minha conta" (gravado em `customization/infos.termsOfUseUrl`).
//
// Quando esse campo está preenchido, ele é o documento oficial do cliente e
// precisa valer em TODA a visão do aluno: o item "Termos de Uso" do menu, o
// link do rodapé e o aviso do cadastro. Antes só o Checkout lia o campo — os
// demais pontos abriam sempre a página interna com o texto padrão, então o
// aluno (e qualquer visitante deslogado) continuava vendo os termos antigos
// mesmo depois de o cliente cadastrar os dele.
//
// A visão do ADMINISTRADOR não usa isto: lá "Termos de Uso" é o contrato entre
// a Blix e o cliente (`config/terms/blix`), que não pode ser substituído.
import { normalizeBannerLink } from './bannerLinks';

// Reaproveita a normalização do banner: o campo é digitado à mão no painel e
// "exemplo.com.br" sem esquema faria `window.open` navegar para
// `https://seuapp.com/exemplo.com.br` em vez de abrir o site do cliente.
export const resolveTermsOfUseUrl = (customInfo) => {
  const url = normalizeBannerLink(customInfo?.termsOfUseUrl);

  // Sem esquema aqui é sinal de que o admin digitou algo que não é link
  // ("em breve", um texto solto): melhor cair no texto padrão do que mandar
  // o aluno para uma rota inexistente.
  return /^https?:\/\//i.test(url) ? url : '';
};
